var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        { attrs: { "label-width": "0" } },
        [
          _c("el-divider", { staticClass: "custom-divider" }, [
            _vm._v(_vm._s(_vm.i18nt("designer.setting.inputButton"))),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: _vm.i18nt("designer.setting.appendButton") } },
        [
          _c("el-switch", {
            model: {
              value: _vm.optionModel.appendButton,
              callback: function ($$v) {
                _vm.$set(_vm.optionModel, "appendButton", $$v)
              },
              expression: "optionModel.appendButton",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }